import { Component, OnInit } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-upload-questions-image',
  templateUrl: './upload-questions-image.component.html',
  styleUrls: ['./upload-questions-image.component.scss']
})
export class UploadQuestionsImageComponent implements OnInit {
  exam: IExam = examDefault;

  files: File[] = [];
  modelError: string;
  constructor(private popoverRef: PopoverRef<UploadQuestionsImageComponent>,
    private examsevice: ExamService, private snackBar: SnackbarService,) { }

  ngOnInit() {
    if (this.examsevice.selectedExams.length === 1) {
      this.exam = this.examsevice.selectedExams[0];
    }

  }
  close() {
    this.popoverRef.close();
  }
  onQuestionFileChange(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.files = event.target.files;
    }
  }
  async uploadQuestionImage() {

    this.modelError = '';
    try {
      this.validateModel();
      if (this.modelError !== '') {
        return
      }
      let formData = new FormData();
      formData.append('examinationID', '' + this.exam.id);
      Array.from(this.files).forEach((file, index) => {
        formData.append('files', file);
      });
      await this.examsevice.uploadExamQuestionsImage(formData).then(s => {
        this.snackBar.success('Image Upload Successfull');
        this.close();
      });
    } catch (error) {
      this.snackBar.error('Error Uploading Image');
    }

  }
  validateModel() {
    if (this.files.length <= 0) {
      this.modelError += "\n*No file selected\n"
    }
  }
}
